// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-node-container {
  position: relative;
  padding: 15px;
  border: 1px solid #546883;
  border-radius: 8px;
  background-color: #ffffff;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.org-node-container:hover {
  transform: scale(0.95);
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2);
  color: cornflowerblue;
}

.org-name {
  margin-top: 5px;
  font-size: 12px;
}

.expand-icon {
  margin-top: 10px;
  font-size: 18px;
  color: #546883;
}

/* Hide the orgchart container on mobile devices */
@media only screen and (max-width: 768px) {
  .orgchart-container {
    display: none;
  }

  /* Show the img container on mobile devices */
  .orgchart-wrapper {
    display: block;
  }

  /* Show the img element on mobile devices */
  .orgchart-wrapper .img-container .mobile-chart {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
}

/* Hide the orgchart wrapper on non-mobile devices (laptops, desktops) */
@media only screen and (min-width: 769px) {
  .orgchart-wrapper {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrgChartPage/OrgChartPageStyle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,qDAAqD;EACrD,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;;EAEA,6CAA6C;EAC7C;IACE,cAAc;EAChB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".org-node-container {\n  position: relative;\n  padding: 15px;\n  border: 1px solid #546883;\n  border-radius: 8px;\n  background-color: #ffffff;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.org-node-container:hover {\n  transform: scale(0.95);\n  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2);\n  color: cornflowerblue;\n}\n\n.org-name {\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n.expand-icon {\n  margin-top: 10px;\n  font-size: 18px;\n  color: #546883;\n}\n\n/* Hide the orgchart container on mobile devices */\n@media only screen and (max-width: 768px) {\n  .orgchart-container {\n    display: none;\n  }\n\n  /* Show the img container on mobile devices */\n  .orgchart-wrapper {\n    display: block;\n  }\n\n  /* Show the img element on mobile devices */\n  .orgchart-wrapper .img-container .mobile-chart {\n    display: block;\n    width: 100%;\n    height: auto;\n    margin: 0 auto;\n  }\n}\n\n/* Hide the orgchart wrapper on non-mobile devices (laptops, desktops) */\n@media only screen and (min-width: 769px) {\n  .orgchart-wrapper {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
